"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Provider = void 0;
Object.defineProperty(exports, "ReducerManager", {
  enumerable: true,
  get: function () {
    return _ReducerManager.default;
  }
});
exports.createReducerManager = void 0;
Object.defineProperty(exports, "createStore", {
  enumerable: true,
  get: function () {
    return _store.default;
  }
});
exports.default = void 0;
Object.defineProperty(exports, "reducerWithKey", {
  enumerable: true,
  get: function () {
    return _reducerWithKey.default;
  }
});
Object.defineProperty(exports, "selectorWithKey", {
  enumerable: true,
  get: function () {
    return _selectorWithKey.default;
  }
});
exports.useReducerManager = void 0;
Object.defineProperty(exports, "useSimpleReducer", {
  enumerable: true,
  get: function () {
    return _useSimpleReducer.default;
  }
});
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _ReducerManager = _interopRequireDefault(require("./ReducerManager"));
var _reducerWithKey = _interopRequireDefault(require("./reducerWithKey"));
var _selectorWithKey = _interopRequireDefault(require("./selectorWithKey"));
var _store = _interopRequireDefault(require("./store"));
var _useSimpleReducer = _interopRequireDefault(require("./useSimpleReducer"));
var _jsxRuntime = require("react/jsx-runtime");
const PropContext = /*#__PURE__*/(0, _react.createContext)({});
const INITIAL_STATE_CACHE = {};
const useReducerManager = function (_ref) {
  let {
    id,
    reducer,
    initialState,
    persist = false
  } = _ref;
  const componentProps = (0, _react.useContext)(PropContext)[id] || {};
  const dispatch = (0, _reactRedux.useDispatch)();
  if (!INITIAL_STATE_CACHE[id] && initialState) {
    INITIAL_STATE_CACHE[id] = typeof initialState === "function" ? initialState(componentProps) : initialState;
  }
  const state = INITIAL_STATE_CACHE[id] || {};
  (0, _react.useEffect)(function () {
    _ReducerManager.default.add(id, (0, _reducerWithKey.default)(id, reducer, state));
    return function () {
      if (!persist) {
        _ReducerManager.default.remove(id);
      }
    };
  }, [id]);
  const dispatchProxy = function (action) {
    if (typeof action === "function") {
      return action(dispatchWithId);
    }
    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }
    return dispatchWithId(action, rest);
  };
  const dispatchWithId = function (action) {
    for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      rest[_key2 - 1] = arguments[_key2];
    }
    return dispatch({
      ...action,
      reducerManagerId: id
    }, ...rest);
  };
  const useSelectorWithId = function (selector) {
    return (0, _reactRedux.useSelector)((0, _selectorWithKey.default)(id, selector, state));
  };
  return [useSelectorWithId, dispatchProxy];
};
exports.useReducerManager = useReducerManager;
const createReducerManager = function (_ref2) {
  let {
    reducer,
    initialState,
    persist = false
  } = _ref2;
  return function (_ref3) {
    let {
      id
    } = _ref3;
    return useReducerManager({
      id,
      reducer,
      initialState,
      persist
    });
  };
};
exports.createReducerManager = createReducerManager;
const CustomProvider = function (_ref4) {
  let {
    store,
    components = {},
    children
  } = _ref4;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRedux.Provider, {
    store: store,
    "data-testid": "CustomProvider",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(PropContext.Provider, {
      value: components,
      children: children
    })
  });
};
exports.Provider = CustomProvider;
var _default = exports.default = _store.default;